<template>
    <div class="TeamChallangeAdminDashboard">
        <div v-if="teamGoal" class="in-progress-challange-view">
            <div class="in-progress-header">
                <div class="left-side">
                    <img src="@/assets/images/theory_image.png" />
                    <div class="headers">
                        <h1>{{ $t(`dashboard.general.lifeskillLabels.${course.lifeskillNumber}`) }}</h1>
                        <h3>{{ journey.name }}</h3>
                    </div>
                </div>
                <div class="right-side">
                    <p v-if="!areGameAndQuizUnlocked">Team Quiz Starts {{ timeToStart }}</p>
                    <div v-if="gameTopPlayer" class="top-game-player">
                        <h5>TOP Game</h5>
                        <div class="avatar-and-name">
                            <img
                                class="golden-rank-icn"
                                src="@/assets/images/golden-rank-icn.png"
                                alt="golden-rank-icon"
                            />
                            <img src="https://picsum.photos/200" :alt="gameTopPlayer.lastName" />
                            <p>{{ gameTopPlayer.firstName }} {{ gameTopPlayer.lastName || '' }}</p>
                        </div>
                    </div>
                    <div class="img-wrapper">
                        <img src="@/assets/images/3dots.png" @click="showOptions = !showOptions" />
                        <div v-if="showOptions" class="options-wrapper">
                            <ul>
                                <li @click="deleteTeamGoalWithGameAndQuiz">Delete team goal</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <TransitionExpandCollapse>
                <div v-if="showTeamMembersProgress" class="players-progress">
                    <table>
                        <tr class="steps-axis">
                            <td class="empty-cell" />
                            <td v-for="index in stepsCount" :key="index" class="step-title"> {{ 'Step ' + index }} </td>
                            <td class="step-title">Quiz</td>
                        </tr>

                        <tbody>
                            <tr
                                v-for="teamMember of teamMembersList"
                                :key="teamMember.displayName"
                                class="player-progress"
                            >
                                <td class="team-member">
                                    <img class="avatar" :src="teamMember.avatar" />
                                    <p class="team-member-name">{{ teamMember.displayName }}</p>
                                </td>
                                <td v-for="index in stepsCount + 1" :key="index">
                                    <div
                                        class="progress-bar-part"
                                        :style="{
                                            background:
                                                teamMemberActualStep(teamMember.displayName) + 1 > index
                                                    ? '#40ACE0'
                                                    : '#241A64'
                                        }"
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </TransitionExpandCollapse>

            <div class="bottom-wrapper">
                <div class="start-info" @click="showTeamMembersProgress = !showTeamMembersProgress">
                    {{ showTeamMembersProgress ? 'Hide All Members Progress' : 'Show All members Progress' }}
                </div>
                <div class="create-buttons">
                    <button
                        v-if="!gameFinished"
                        :disabled="loading || !areGameAndQuizUnlocked"
                        class="button-light-blue"
                        @click="game ? joinExistingGame(game.id) : handleNewGame()"
                    >
                        <div class="btn-text-content">
                            <p class="sub-info">WARM UP</p>
                            <p class="main-info"> {{ game ? 'Join existing game' : 'Team Memo Game' }}</p>
                        </div>
                        <svgicon icon="arrow-right" class="icon" />
                    </button>
                    <button v-else class="game-leaderboard-btn" @click="openLeaderBoardPopup(game.id)">
                        Game Leaderboard
                    </button>

                    <button
                        v-if="!quizFinished"
                        :disabled="loading || !areGameAndQuizUnlocked"
                        class="button-light-blue"
                        @click="quiz ? joinExistingQuiz(quiz.id) : handleNewQuiz()"
                    >
                        <div class="btn-text-content">
                            <p class="sub-info">COMPETITION</p>
                            <p class="main-info"> {{ quiz ? 'Join existing quiz' : 'Team Quiz' }}</p>
                        </div>
                        <svgicon icon="arrow-right" class="icon" />
                    </button>
                    <button v-else class="game-leaderboard-btn" @click="openLeaderBoardPopup(quiz.id)">
                        Quiz Leaderboard
                    </button>
                </div>
            </div>
        </div>

        <div v-else class="create-team-challange-view">
            <h2> Team learning journey </h2>
            <p>Select a journey and do your quiz with your team</p>
            <button @click="goToCreateTeamChallangeView"> Create new week challenge </button>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

import apolloClient from '@/apollo-client';
import gql from 'graphql-tag';
import moment from 'moment';

import deleteTeamGoal from './graphql/DeleteTeamGoal.gql';

import LeaderBoard from './LeaderBoard';
import TransitionExpandCollapse from '@/components/TransitionExpandCollapse';

export default {
    components: {
        // eslint-disable-next-line
        LeaderBoard,
        TransitionExpandCollapse
    },

    props: {
        team: {
            type: Object,
            required: true
        },

        teamGoal: {
            type: Object,
            required: false
        },

        doneJourneysIds: {
            type: Array
        }
    },

    data() {
        return {
            teamJourneyProgressesList: [],
            teamGoals: [],
            teamMembersList: [],
            showTeamMembersProgress: false,
            loading: false,
            showOptions: false,
            gameLeaderBoard: []
        };
    },

    computed: {
        ...mapGetters({
            getJourneyById: 'moduleCourse/getJourneyById'
        }),

        course() {
            return this.$store.state.moduleCourse.courses[this.journey?.courseId];
        },

        journey() {
            return this.getJourneyById(this.teamGoal?.journeyId);
        },

        progress() {
            return this.teamJourneyProgressesList.reduce(
                (total, p, idx, src) => {
                    total.courses[p.courseId] = total.courses[p.courseId] || this.course;
                    if (p.activity === 'stepGroupQuiz') {
                        total.avatarsCompleted[p.stepGroupId] = total.avatarsCompleted[p.stepGroupId] || {};
                        total.avatarsCompleted[p.stepGroupId][p.avatar] = {
                            displayName: p.displayName,
                            url: p.avatar
                        };
                    } else {
                        total.avatarCurrentStep[p.stepId] = total.avatarCurrentStep[p.stepId] || {};
                        total.avatarCurrentStep[p.stepId][p.avatar] = {
                            displayName: p.displayName,
                            url: p.avatar
                        };
                    }
                    return total;
                },
                {
                    courses: {},
                    avatarsCompleted: {},
                    avatarCurrentStep: {}
                }
            );
        },

        timeToStart() {
            const now = moment();
            const endDate = moment(this.teamGoal.stop);

            return endDate.from(this.teamGoal.endDate);
        },

        areGameAndQuizUnlocked() {
            const now = moment();
            const endDate = moment(this.teamGoal.stop);

            return endDate.diff(now) < 0;
        },

        games() {
            return this.$store.getters['moduleMemoransier/games'].filter(game => {
                const options = JSON.parse(game.options);

                return (
                    options.teamId === this.teamGoal?.teamId &&
                    options.courseId === this.course.id &&
                    options.stepGroupId === this.teamGoal?.journeyId
                );
            });
        },

        publishedGames() {
            return this.games.filter(game => game.published);
        },

        stepsCount() {
            return this.journey.stepIds.length;
        },

        game() {
            return this.games.find(game => game.name === 'game');
        },

        quiz() {
            return this.games.find(game => game.name === 'Quiz game');
        },

        gameFinished() {
            return this.game && this.game.startedAt && !this.game.running;
        },

        quizFinished() {
            return this.quiz && this.quiz.startedAt && !this.quiz.running;
        },

        gameTopPlayer() {
            return this.gameLeaderBoard && this.gameLeaderBoard.length && this.gameLeaderBoard[0];
        }
    },

    async mounted() {
        const response = await apolloClient.query({
            fetchPolicy: 'no-cache',
            query: gql`
                query {
                    teamLeaderboardFullsList {
                        avatar
                        braindates
                        displayName
                        teamId
                        teamName
                    }
                    teamJourneyProgressesList {
                        avatar
                        courseId
                        displayName
                        stepId
                        stepGroupId
                        teamId
                        teamName
                        activity
                    }
                }
            `
        });

        this.teamMembersList = response.data.teamLeaderboardFullsList;
        this.teamJourneyProgressesList = response.data.teamJourneyProgressesList;

        this.gameRefreshingInterval = setInterval(async () => {
            await this.refreshGame();
            await this.refreshLeaderBoard();
        }, 1000);
    },

    methods: {
        goToCreateTeamChallangeView() {
            this.$router.push({ name: 'CreateTeamChallange', params: { teamId: this.team.id } });
        },

        avatars(stepId) {
            const stepGroupIds = [...this.course.stepGroupIds].reverse();
            const ids = stepGroupIds
                .map(sgid => this.stepGroup(sgid))
                .filter(sg => sg.stepIds.indexOf(stepId) > -1)
                .flatMap(sg => [sg.id, ...[...sg.stepIds].reverse()]);

            let prevAvatars = [];

            for (const cur of ids) {
                let completed = this.progress.avatarsCompleted[cur] || {};
                let inProgress = this.progress.avatarCurrentStep[cur] || {};
                let avatars = { ...completed, ...inProgress };

                avatars = Object.keys(avatars)
                    .filter(a => prevAvatars.indexOf(a) === -1)
                    .map(a => avatars[a]);
                avatars.forEach(a => prevAvatars.push(a.url));

                if (cur === stepId) {
                    return Object.values(avatars);
                }
            }

            return [];
        },

        stepGroup(stepGroupId) {
            return this.$store.state.moduleCourse.stepGroups[stepGroupId];
        },

        async handleNewGame(dataId = 'techdata') {
            this.loading = true;

            const options = {
                name: 'game',
                role: '',
                options: {
                    teamId: this.teamGoal.teamId,
                    dataId,
                    courseId: this.course.id,
                    stepGroupId: this.teamGoal.journeyId
                }
            };

            await this.$store.dispatch('moduleMemoransier/createGame', options);

            const newGame = this.games.find(game => game.name === 'game');

            await this.publishGame(newGame.id);

            await this.updateTeamGoal();

            this.joinExistingGame(newGame.id);

            this.loading = false;
        },

        joinExistingGame(gameId) {
            this.$router.push({
                name: 'MemoransierGameView',
                params: { gameId }
            });
        },

        joinExistingQuiz(quizId) {
            this.$router.push({
                name: 'MemoransierGameView',
                params: { gameId: quizId }
            });
        },

        async handleNewQuiz() {
            this.loading = true;

            const options = {
                name: 'Quiz game',
                role: '',
                options: {
                    teamId: this.teamGoal.teamId,
                    courseId: this.course.id,
                    stepGroupId: this.teamGoal.journeyId
                }
            };

            await this.$store.dispatch('moduleMemoransier/createGame', options);

            const quiz = this.games.find(game => game.name === 'Quiz game');

            await this.publishGame(quiz.id);

            await this.updateTeamGoal();

            this.joinExistingQuiz(quiz.id);

            this.loading = false;
        },

        publishGame(gameId) {
            this.$store.dispatch('moduleMemoransier/publishGame', gameId);
        },

        async deleteTeamGoalWithGameAndQuiz() {
            try {
                if (this.game) {
                    this.$store.dispatch('moduleMemoransier/deleteGame', this.game.id);
                }

                if (this.quiz) {
                    this.$store.dispatch('moduleMemoransier/deleteGame', this.quiz.id);
                }

                await apolloClient.mutate({
                    mutation: deleteTeamGoal,
                    variables: {
                        id: this.teamGoal.id
                    }
                });

                location.reload();
            } catch (error) {
                console.error(error);
            }
        },

        teamMemberActualStep(teamMemberName) {
            let actualStepNumber = 0;

            this.journey.stepIds.forEach((stepId, i) => {
                this.avatars(stepId).some(avatar => {
                    if (avatar.displayName === teamMemberName) {
                        actualStepNumber = i + 1;
                    }
                });
            });

            return actualStepNumber;
        },

        async refreshGame() {
            await this.$store.dispatch('moduleMemoransier/refresh');
        },

        openLeaderBoardPopup(gameId) {
            this.$modal.open({
                component: LeaderBoard,
                props: {
                    gameId,
                    teamGoal: this.teamGoal
                },
                target: 'app-modal'
            });
        },

        async updateTeamGoal() {
            await apolloClient.mutate({
                fetchPolicy: 'no-cache',
                mutation: gql`
                    mutation UpdateTeamGoalMutation($memoGameId: UUID, $quizGameId: UUID, $id: UUID!) {
                        __typename
                        updateTeamGoal(
                            input: { patch: { memoGameId: $memoGameId, quizGameId: $quizGameId }, id: $id }
                        ) {
                            clientMutationId
                            teamGoal {
                                shoutout
                                start
                                stop
                                memoGameId
                                quizGameId
                                teamId
                                journeyId
                                createdBy
                            }
                        }
                    }
                `,
                variables: {
                    memoGameId: this.game?.id,
                    quizGameId: this.quiz?.id,
                    id: this.teamGoal.id
                }
            });
        },

        async refreshLeaderBoard() {
            this.gameLeaderBoard =
                this.gameFinished && (await this.$store.dispatch('moduleMemoransier/getLeaderboard', this.game.id));
        }
    }
};
</script>

<style lang="scss" scoped>
.TeamChallangeAdminDashboard {
    display: flex;
    background: #18194c;
    box-shadow: 0px 2px 23px rgba(79, 79, 79, 0.1);
    border-radius: 8px;
    justify-content: center;
    .create-team-challange-view {
        display: flex;
        flex-direction: column;
        align-items: center;
        h2 {
            font-weight: 500;
            font-size: 22px;
            line-height: 26px;
            color: rgba(255, 255, 255, 0.8);
            margin-top: 70px;
            margin-bottom: 10px;
            @media (max-width: 600px) {
                font-size: 18px;
            }
        }
        p {
            color: #758ebf;
            font-weight: normal;
            font-size: 14px;
            line-height: 22px;
            margin: 0;
            margin-bottom: 25px;
            @media (max-width: 600px) {
                font-size: 10px;
            }
        }
        button {
            width: 239px;
            height: 56px;
            background: #40ace0;
            border-radius: 4.76651px;
            border: none;
            font-weight: 500;
            font-size: 16px;
            line-height: 19px;
            color: rgba(255, 255, 255, 0.9);
            margin-bottom: 75px;
            cursor: pointer;
            @media (max-width: 600px) {
                font-size: 10px;
                width: 163.27px;
                height: 38.26px;
            }
        }
    }
    .in-progress-challange-view {
        margin: 30px;
        width: 100%;
        .in-progress-header {
            display: flex;
            justify-content: space-between;
            .left-side {
                display: flex;
                img {
                    width: 52px;
                    height: 52px;
                }
                .headers {
                    margin-left: 20px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    h1 {
                        font-style: normal;
                        font-weight: 500;
                        font-size: 20px;
                        line-height: 23px;
                        color: #6b8ace;
                        margin: 0;
                    }
                    h3 {
                        font-size: 14px;
                        line-height: 22px;
                        color: #ababab;
                        margin: 0;
                        font-style: normal;
                        font-weight: normal;
                    }
                }
            }

            .right-side {
                display: flex;
                align-items: center;
                .top-game-player {
                    margin-right: 50px;
                    h5 {
                        font-style: normal;
                        font-weight: bold;
                        font-size: 14px;
                        line-height: 15px;
                        color: #48546f;
                        margin-bottom: 10px;
                        margin-top: 0;
                    }
                    .avatar-and-name {
                        display: flex;
                        align-items: center;
                        .golden-rank-icn {
                            width: 27px;
                            height: 27px;
                            margin-right: 10px;
                        }
                        img {
                            width: 34px;
                            height: 34px;
                            border-radius: 50%;
                        }
                        p {
                            font-style: normal;
                            font-weight: 600;
                            font-size: 14px;
                            line-height: 16px;
                            margin: 0 0 0 10px;
                            color: rgba(255, 255, 255, 0.8);
                        }
                    }
                }
                p {
                    font-weight: normal;
                    font-size: 14px;
                    line-height: 22px;
                    color: rgba(139, 208, 224, 0.5);
                    margin-right: 20px;
                }
                .img-wrapper {
                    position: relative;
                    img {
                        cursor: pointer;
                    }
                    .options-wrapper {
                        background: rgba(139, 208, 224, 0.5);
                        color: rgba(255, 255, 255, 0.9);
                        font-weight: 500;
                        font-size: 14px;
                        position: absolute;
                        width: 200px;
                        border-radius: 10px;
                        padding-left: 10px;
                        ul {
                            list-style-type: none;
                            padding: 0;
                            li {
                                cursor: pointer;
                            }
                        }
                    }
                }
            }
        }

        img {
            width: 20px;
        }
        .bottom-wrapper {
            display: flex;
            padding-top: 50px;
            justify-content: space-between;
            align-items: center;
            .start-info {
                font-size: 14px;
                line-height: 22px;
                color: rgba(139, 208, 224, 0.5);
                cursor: pointer;
            }

            .create-buttons {
                display: flex;
                .button-light-blue {
                    width: 174px;
                    height: 56px;
                    background: #346fc8;
                    border-radius: 5px;
                    border: none;
                    font-weight: 500;
                    font-size: 14px;
                    line-height: 16px;
                    color: rgba(255, 255, 255, 0.9);
                    margin-left: 10px;
                    cursor: pointer;
                    outline: none;
                    padding: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    &:disabled {
                        opacity: 0.3;
                    }
                    .btn-text-content {
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        p {
                            margin: 2px 0;
                            text-align: left;
                        }
                        .sub-info {
                            font-weight: 500;
                            font-size: 10px;
                            line-height: 12px;
                            color: rgba(255, 255, 255, 0.4);
                        }
                        .main-info {
                            font-weight: 600;
                            font-size: 12px;
                            line-height: 12px;
                            color: white;
                        }
                    }
                    .icon {
                        width: 15px;
                        fill: white;
                    }
                }

                .game-leaderboard-btn {
                    width: 174px;
                    height: 56px;
                    background: #18194c;
                    box-shadow: 0px 2px 23px rgba(79, 79, 79, 0.1);
                    border-radius: 8px;
                    border: 1px solid #346fc8;
                    color: #346fc8;
                    cursor: pointer;
                    outline: none;
                    text-align: center;
                    margin-left: 10px;
                }
            }
        }

        .players-progress {
            display: flex;
            flex-direction: column;
            justify-content: center;
            table {
                width: 100%;
                .steps-axis {
                    letter-spacing: 0.02em;
                    color: #a4b1cd;
                    opacity: 0.5;
                    font-size: 10px;
                    line-height: 11px;
                    padding: 20px 0;
                    td {
                        text-align: right;
                        margin-right: 10px;
                    }
                }

                .player-progress {
                    display: flex;
                    align-items: flex-end;
                    margin-bottom: 30px;

                    td {
                        &:nth-of-type(2) {
                            .progress-bar-part {
                                border-top-left-radius: 25px;
                                border-bottom-left-radius: 25px;
                            }
                        }

                        &:last-of-type {
                            .progress-bar-part {
                                border-top-right-radius: 25px;
                                border-bottom-right-radius: 25px;
                            }
                        }
                    }

                    .progress-bar-part {
                        height: 16px;
                    }
                }

                tr {
                    display: flex;
                    justify-content: space-between;
                    td {
                        flex: 1;
                    }
                    .team-member {
                        display: flex;
                        .avatar {
                            width: 32px;
                            height: 32px;
                            border-radius: 50%;
                        }
                        .team-member-name {
                            font-size: 10px;
                            line-height: 12px;
                            margin-left: 20px;
                        }
                    }
                }
            }

            .btn-toggle-collapse {
                padding: 10px;
                background-color: inherit;
                color: rgba(139, 208, 224, 0.5);
                border: none;
                outline: none;
                cursor: pointer;
            }
        }
    }
}

.list-enter {
    opacity: 0;
}
.list-enter-active {
    animation: slide-in 0.5s ease-out forwards;
}
.list-leave-to,
.list-leave-active {
    opacity: 0;
    animation: slide-out 0.5s ease-out forwards;
}

@keyframes slide-in {
    from {
        max-height: 0;
        margin-bottom: 0;
    }
    to {
        max-height: 34px;
        margin-bottom: 30px;
    }
}
@keyframes slide-out {
    from {
        max-height: 34px;
        margin-bottom: 30px;
    }
    to {
        max-height: 0;
        margin-bottom: 0;
    }
}
</style>
